import { render, staticRenderFns } from "./ComptonEffectViz.vue?vue&type=template&id=1b36d81e&scoped=true"
import script from "./ComptonEffectViz.vue?vue&type=script&lang=js"
export * from "./ComptonEffectViz.vue?vue&type=script&lang=js"
import style0 from "./ComptonEffectViz.vue?vue&type=style&index=0&id=1b36d81e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36d81e",
  null
  
)

export default component.exports